import React from "react"

import PillUser from "../../../../../gd-components/molecules/pill/pill-user";

export default function FieldUser_DropdownValueNotEmpty(props:any) {

    let value :any  = false

    if (!props.option.value) {
        value = <span>{props.option.label}</span>
    } else {

        value = <PillUser userId        = {props.option.value}
                          size          = {26}
                          value         = {props.option}
                          onClick       = {props.onClick}
                          className     = 'm-t-4 m-b-4 m-r-4'
        />


    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form h-36", props.className)} onClick={props.onClick}>
                {value}
            </div>
            {props.children}
        </React.Fragment>
    )
}